import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import IRadioWidgetProps from "./IRadioWidgetPropsType";
import "../../../assets/sass/widgets/radioWidget.scss";
import { checkForReadOnly, imagePathurl, isOptionHidden } from "../../utils/utils";

interface IRadioWidgetStateProps {
    radio: {
        total: number;
        current: number;
    };
}

/**
 * @class RadioButton
 * @category Widgets
 * @description this component renders the radio button and binds  the action for those..
 * this performs the error validation based on the configuration passed to this component
 */
class RadioWidget extends React.Component<IRadioWidgetProps, IRadioWidgetStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            radio: {
                total: this.props.schema.anyOf.length,
                current: 0,
            },
        };
    }
    componentDidMount() {
        const { value, schema, onChange } = this.props;
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        if (typeof value !== "string" || !value) {
            onChange(schema.default || "");
        }
        if (schema.default !== "") {
            removeFieldIdFromStore(this.props.id);
        }
    }

    onKeyPress(e: any) {
        const {
            radio: { total, current },
        } = this.state;
        const { schema, onChange } = this.props;
        let next = current;
        if (e.keyCode === 38 && current <= total && current > 0) {
            next = current - 1;
        } else if (e.keyCode === 40 && current < total && current >= 0) {
            next = current + 1;
        }
        this.setState((prevState: IRadioWidgetStateProps) => {
            prevState.radio.current = next;
            return prevState;
        });
        const value = schema.anyOf.find((s, i) => i === next);
        if (value) {
            onChange(value.enum[0]);
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const { value: prevValue, schema: prevSchema, formData: prevFormData } = prevProps;
        const { value, schema, onChange, id, formData, adminData } = this.props;
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        const tempArr = schema.anyOf.filter((item) => item.enum[0] === value);
        const prevWarrantyType = prevFormData?.projectDetails?.warrantyType;
        const currentWarrantyType = formData?.projectDetails?.warrantyType;
        // clears off field values if "Mail Warranty to" radio is changed.
        let globalKey;
        if (id.includes("mailWarrantyInfo")) {
            globalKey = "mailAddress";
        }
        if (value !== prevValue) {
            const { selectAddress } = this.props.dynamicFormActions;
            const address = {
                street: "",
                city: "",
                zip: "",
                state: "",
                postalCode: "",
                countryCode: "USA",
            };
            selectAddress({ key: globalKey, payload: address });
        }
        if (typeof value !== "string") {
            onChange(schema.default || "");
            return;
        }

        // Removing previously selected value if it's discontinued for the selected warranty type.
        if ( prevWarrantyType !== currentWarrantyType && value) {
            const isAdmin = adminData?.userInfo?.isAdmin === true;
            if (value) {
                const selectedOption = schema.anyOf?.find(option => option.enum[0] === value);
                const isDiscontinued = selectedOption?.const?.IsDiscon === true;
                const shouldRemove = !isAdmin && isDiscontinued;
                if ( shouldRemove ) {
                    console.log(`Removing discontinued field: ${this.props.id}`);
                    removeFieldIdFromStore(this.props.id);
                    setTimeout(() => { 
                        onChange(schema.default ?? "")
                    }, 1);
                }
            }
        }
        if (prevValue !== value) {
            // triggered onchange of a radio button
            if (value) {
                removeFieldIdFromStore(this.props.id);
            }
            onChange(value);
        } else if (tempArr.length > 0 && tempArr[0].enum[0] === value) {
            // called upon if there is a new schema which has a previous selectionn within already
            onChange(value);
        } else if (
            // called when there is a new schema list
            prevSchema.anyOf.length !== schema.anyOf.length ||
            !prevSchema.anyOf.every((item) => schema.anyOf.some((elem) => elem.title === item.title))
            // prevSchema.anyOf.every((x) => !schema.anyOf.includes(x))
        ) {
            setTimeout(function () {
                schema.default ? onChange(schema.default) : onChange("");
            }, 1);
        }
    }

    render() {
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const { id, value, schema, onChange, isSubmittedForm, adminData } = this.props;
       
        const isAdmin = adminData?.userInfo?.isAdmin === true;

        let displayNone = isOptionHidden(value) && !this.props.isSolarCertified ? "d-none" : "";
        if (!displayNone){
            displayNone = this.props.isSolarCertified && schema.const.checkSolarCertified ? "d-none" : "";
        }

        const radioList = schema.anyOf.map((option, index) => {
            const isActive = value === option.enum[0];
            const isDiscontinuedProduct = option?.const?.IsDiscon || false;

            // Hide radio option when IsDiscon is true and the user is not an Admin
            const hideOption = !isAdmin && isDiscontinuedProduct; 

            return (
                <div
                    key={`${id} ${index}`}
                    className={`
              ${displayNone}
              ${hideOption ? "d-none" : ""}
              ${option.const.label === "NA" ? "d-none" : ""}
              ${schema.const && schema.const.isWide ? "col-sm-5" : "col-sm-12"}
              ${schema.const && schema.const.showActiveSelection ? "radiobtn-selection-wrapper" : "radiobtn-wrapper"}
            `}
                >
                    <div key={`Radiobtn-${index}`} id={`${id}-${index}`} className="radio-btn">
                        <img
                            className="radio-img"
                            tabIndex={schema.const.tabIndex}
                            src={isActive ? `${getimagePath}radio-filled.png` : `${getimagePath}radio-empty.png`}
                            alt="Radio-img"
                            onClick={
                                checkForReadOnly(schema.const, isSubmittedForm)
                                    ? () => {}
                                    : () => {
                                          onChange(option.enum[0]);
                                      }
                            }
                            onKeyDown={(e) => {
                                if (e.keyCode == 13) {
                                    if (!checkForReadOnly(schema.const, isSubmittedForm)) {
                                        onChange(option.enum[0]);
                                    }
                                } else if (e.keyCode === 38 || e.keyCode === 40) {
                                    this.onKeyPress(e);
                                }
                            }}
                        />
                        {option.const.label && (
                            <div
                                className="radio-label"
                                onClick={
                                    checkForReadOnly(schema.const, isSubmittedForm)
                                        ? () => {}
                                        : () => onChange(option.enum[0])
                                }
                            >
                                {option.const.label}
                            </div>
                        )}
                        {option.const.helpText && (
                            <div className="info-icon">
                                <span className="tooltip">{option.const.helpText}</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        });

        return (
            <>
                {schema.const && schema.const.label && <label className={displayNone}> {schema.const.label} </label>}
                <div id={id} className={`radiobtn-group row ${displayNone}`}>
                    {radioList}
                </div>
                {value === "" && this.props.errorDetails[id] && this.props.errorDetails[id].length > 0 && (
                    <div className="error-message-radio">
                        {this.props.errorDetails[id].map((msg, id) => (
                            <p key={id}>
                                <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                &nbsp;
                                {msg}
                            </p>
                        ))}
                    </div>
                )}
            </>
        );
    }
}

export function mapStateToProps(state) {
    const contractorSettings = state.dynamicFormInfo.contractorSettings || {};
    return {
        buildingAddress: state.dynamicFormInfo.global.buildingAddress,
        mailAddress: state.dynamicFormInfo.global.mailAddress,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
        isSolarCertified: contractorSettings.isSolarCertified || false,
        adminData: state.adminData,
        formData: state.dynamicFormInfo.warrantyInfo.residentialWarrantyForm,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RadioWidget);
